import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { FlexLayoutModule } from "@angular/flex-layout";
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { TokenInterceptor } from './authentication/interceptor/token.interceptor';
import { HttpService } from './services/http/http.service';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FullComponent } from './layouts/full/full.component';
import { SidebarComponent } from './layouts/full/sidebar/sidebar.component';
import { AuthGuardService } from './authentication/guards/auth-guard.service';
import { PerfectScrollbarModule , PERFECT_SCROLLBAR_CONFIG , PerfectScrollbarConfigInterface } from 'ngx-perfect-scrollbar';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';



import { MaterialModule } from "./material.module";
import { SharedModule } from "./shared/shared.module";
import { SpinnerComponent } from './shared/spinner.component';
import { LoaderService } from './services/loader/loader.service';
import { ToastrModule } from 'ngx-toastr';
import { Auth0Service } from './authentication/auth0/auth0.service';
import { LandingPageComponent } from './landing-page/landing-page.component';
import { LandingPageNewComponent } from './landing-page-new/landing-page-new.component';
import { DrawingLandingPageComponent } from './drawing-landing-page/drawing-landing-page.component';
import { WinnerLandingPageComponent } from './winner-landing-page/winner-landing-page.component';

import { environment } from "../environments/environment"
import { AngularFireModule } from '@angular/fire';
import { AngularFirestoreModule } from '@angular/fire/firestore';
import { AngularFireAuthModule } from "@angular/fire/auth";
import { DynamicPathGuard } from './shared/dynamic-routing/dynamic-path.guard';
import { DynamicBoardsGuard } from './shared/dynamic-routing/dynamic-boards.guard';
const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelSpeed: 2,
  wheelPropagation: true
};

/**
* This is an initial module, our app gets started from this module. It contains all dependencies and services.
*/

@NgModule({
  declarations: [
    AppComponent,
    FullComponent,
    SidebarComponent,
    SpinnerComponent,
    LandingPageComponent,
    LandingPageNewComponent,
    DrawingLandingPageComponent,
    WinnerLandingPageComponent
  ],
  imports: [
    BrowserModule,
    // routing,
    AppRoutingModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    MaterialModule,
    PerfectScrollbarModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    AngularFireModule.initializeApp(environment.firebaseConfig),
    AngularFirestoreModule,
    AngularFireAuthModule,
    NgxSkeletonLoaderModule
  ],
  providers: [
    HttpService,
    Auth0Service,
    LoaderService,
    AuthGuardService,
    {
      provide: PERFECT_SCROLLBAR_CONFIG,
      useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
    },
    {provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true},
    DynamicPathGuard,
    DynamicBoardsGuard
  ],
  // entryComponents: [RenderNameComponent],
  bootstrap: [AppComponent]
})
export class AppModule { }
